import { post } from '@/service/request';
const otp = 'api/otpCheck';

/**
 * 比對發送OTP行動電話資訊
 * @param {String} mobile 接收OTP驗證碼的手機
 */
export function postCheckBDPOTP(mobile) {
    return post(`${otp}/checkBDPOTP`, { mobile });
}

/**
 * 比對地址電話Email變更的要保人、被保人、收費資訊
 */
export function postCheckBDP() {
    return post(`${otp}/checkBDP`);
}
